/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Custom_Page_Icon_StariconInputs */

const en_enum_custom_page_icon_staricon = /** @type {(inputs: Enum_Custom_Page_Icon_StariconInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Star`)
};

const de_enum_custom_page_icon_staricon = /** @type {(inputs: Enum_Custom_Page_Icon_StariconInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stern`)
};

/**
* | output |
* | --- |
* | "Star" |
*
* @param {Enum_Custom_Page_Icon_StariconInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const enum_custom_page_icon_staricon = /** @type {((inputs?: Enum_Custom_Page_Icon_StariconInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Custom_Page_Icon_StariconInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_custom_page_icon_staricon(inputs)
	return de_enum_custom_page_icon_staricon(inputs)
});